<template>
    <div class="report-wrap">
    
      <PageMessage :title="'Create A Report For ' + projectName" :invert="true" class="page-message">
       Use the buttons and filters to tailor how/what data is shown. <br />
       You can then use the report setup options to toggle what you'd like to be displayed. <br />
       For the best results you should... <br />
       <ol>
        <li>Hide enough table headings so the visible columns have enough space to stop the content spreading over too many lines (eg SERP, Pause &amp; Delete serve no purpose on the report)</li>
        <li>Toggle off Filters &amp; Buttons</li>
        <li>Use Google Chrome (Firefox currently has an issue with the circles around the figures at the top)</li>
      </ol>
       When you're happy click "create pdf" to preview/download your report. <br />
       The PDF generator only allows for upto 50 keywords to be shown in the table on each PDF (all keywords can be downloaded by using the "Keyword Download" report).
		</PageMessage>

      <div class="control">
        <h2 class="control-heading">Report Setup</h2>
        <FormInput 
          type="checkbox" 
          v-model="show" 
          :items="[{ _id: 'overview', label: 'Overview' },{ _id: 'graph', label: 'Graph' },{ _id: 'table', label: 'Keyword Table' },{ _id: 'filters', label: 'Filters' },{ _id: 'buttons', label: 'Buttons' },{ _id: 'preview', label: 'Show Preview First' }]"
          :noMarginBottom="true"
        />
        <span :class="{'large-button':true,disabled:generatingReport}" @click="generateReport" v-html="generatingReport?'Generating...':'Create PDF'" />
      </div>
      <div>
        <vue-html2pdf
            :show-layout="true"
            :float-layout="false"
            :enable-download="!preview"
            :preview-modal="preview"
            :paginate-elements-by-height="1000000"
            filename="report"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="landscape"
            pdf-content-width="1100px"
            @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasDownloaded="hasDownloaded"
            ref="html2Pdf"
            :html-to-pdf-options="htmlToPdfOptions"
        >
            <section slot="pdf-content">
              <Project 
                :report="true" 
                :generatingReport="generatingReport" 
                :showForReport="showIt"
                @project-info="projectInfo"
              />
            </section>
            
        </vue-html2pdf>
      </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'
import Project from './Project.vue';
import FormInput from './../components/Form/Input.vue'
import PageMessage from './../components/PageMessage.vue'
// https://github.com/kempsteven/vue-html2pdf#html-to-pdf-options
export default {
  name: "Report",
  components: {Project,VueHtml2pdf,FormInput,PageMessage},
  data() {
    return {
      show: ['graph','filters','buttons','table','overview','preview'],
      generatingReport: false,
      chartReady: false,
      projectName: '',
      htmlToPdfOptions: {
          margin: 0,
          filename: `report.pdf`,
          image: {
              type: 'jpeg', 
              quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
              scale: 2,
              useCORS: true,
              scrollX:0,
              scrollY:0
          },
          jsPDF: {
              unit: 'in',
              format: 'a4',
              orientation: 'landscape'
          }
      }

    }
  },
  computed: {

    preview() {

      return this.show.indexOf('preview') >= 0;

    },

    showIt() {

      let s = {};

      this.show.forEach ( function (n) {

        s[n] = true;

      })

      s.showFiltering = !this.generatingReport;

      return s;

    }

  },
  methods: {
    ...mapMutations('general',['updateLoadingText']),
    projectInfo(info) {

      this.projectName = info.name;

    },
    hasStartedGeneration() {
     this.generatingReport = true;
    },
    hasDownloaded($event) {
      this.updateLoadingText();
    },
    onProgress($event) {
     this.generatingReport = $event < 100;
    },
    chartIsReady () {
    },
    generateReport () { 
      this.generatingReport = true;
      setTimeout( function () {
        this.$refs.html2Pdf.generatePdf();
      }.bind(this), 100 );
    } 
  }
};
</script>
<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.report-wrap {
  position: relative;
  background: white;
  z-index: 99999;
  .control {
    position: absolute;
    right: 20px;
    top: 60px;
    border: 2px solid @darkContrast;
    z-index: 99999;
    padding: 10px;
    width: 260px;
    box-sizing: border-box;
    background-color: #fff;
    .control-heading {
      font-weight: 400;
      font-size: 18px;
      line-height: 1em;
      margin-bottom: 10px;
    }
  }
  .info-panel {
    box-shadow: none !important;
		border: none !important;
  }
}
@media screen and (min-width: 540px) {
  .page-message {
    padding-right: 300px !important;
  }
}
</style>
<style lang="less">
.report-wrap {
  .info-panel, .table-wrap {
    box-shadow: none !important;
		border: none !important;
  }
}
</style>